import background from '../assets/img/authBg.png';
import logo from '../assets/img/logo.svg';
import logoGreen from '../assets/img/logo_green.svg';
import iconHome from '../assets/img/icon-home.svg';
import iconClock from '../assets/img/icon-clock.svg';
import iconBell from '../assets/img/icon-bell.svg';
import iconUser from '../assets/img/icon-user.png';

export const LOGIN_BACKGROUND = background;
export const LOGIN_BACKGROUND_COLOR = '#FFFFFF';
export const LOGO = logo;
export const LOGO_GREEN = logoGreen;
export const ICON_USER = iconUser;
export const ICON_HOME = iconHome;
export const ICON_CLOCK = iconClock;
export const ICON_BELL = iconBell;

export const appName = 'Pulsar';
export const appVersion: string = import.meta.env.VITE_APP_VERSION ?? '';
/** Which build is running: only deploy_canary.yml sets VITE_APP_CHANNEL. */
export const appChannel: 'stable' | 'canary' =
  import.meta.env.VITE_APP_CHANNEL === 'canary' ? 'canary' : 'stable';
export const lastCommit: string =
  import.meta.env.VITE_APP_LAST_COMMIT ?? import.meta.env.LAST_COMMIT ?? '';

export const getEnvironmentSuffix = (): string => {
  const envRegex = /(prod|stage|dev)/i;
  const match = appVersion.match(envRegex);
  // if tag already includes env (eg. 5.3.21+prod), don't add it again
  if (match) return '';
  const env = import.meta.env.VITE_APP_ENV;
  return env ? `+${env}` : '';
};

export const getAppVersionLabel = (): string => {
  if (import.meta.env.DEV) {
    return 'local';
  }
  if (!appVersion) {
    return lastCommit;
  }
  return appVersion.startsWith('v') ? appVersion : `v${appVersion}`;
};

export const videoApiBaseUrl =
  import.meta.env.VITE_VIDEO_API_BASE_URL ?? 'https://video.pulsarito.com';
